import { defineComponent, h, useAttrs } from 'vue'
import { VList } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (normalized.density == null && hasBooleanishAttr(attrs.dense)) {
    normalized.density = 'compact'
  }

  delete normalized.dense

  return normalized
}

export default defineComponent({
  name: 'VListCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VList, normalizeAttrs(attrs), slots)
  }
})
